import { useEffect, useState } from "react";
import { User } from "../../utils/database";
import { usersService } from "../../services/usersService";
import useToken from "../../../../hooks/auth/useToken";

interface Props {
  userId: string;
}

export default function useUser({ userId }: Props) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { token } = useToken();

  const getUser = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await usersService.getUserWithKYC(userId, token);
      const userData = data?.data?.user;
      setUser(userData);
    } catch (err: any) {
      setError(err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      getUser();
    }
    // tu peux ajouter userId comme dépendance si tu veux récupérer un nouvel utilisateur quand il change
  }, [userId]);

  return { user, loading, error };
}
